export class DynamodbTableRestoreDestination {
    'awsDynamodb';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "awsDynamodb",
            "baseName": "awsDynamodb",
            "type": "AwsDynamoDBDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DynamodbTableRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
